import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Outlet, useOutletContext } from 'react-router-dom'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import { fetchMissionDataByProps, fetchMissionDataTypesByGroup } from '@services/data.service'

import './alerts.styl'

function Alerts() {
  const { map } = useOutletContext()
  const queryClient = useQueryClient()

  const { activeProject } = useSelector(state => state.missionSetup)
  const { sourcesActiveNames } = useSelector(state => state.alerts)

  const { data: alerts } = useQuery({
    queryKey: [
      'alerts', activeProject?.id, sourcesActiveNames,
    ],
    queryFn: () => fetchMissionDataByProps(activeProject?.id, 'alert', sourcesActiveNames),
    enabled: !!activeProject?.id && !!sourcesActiveNames,
  })

  const refetchAlerts = () => {
    queryClient.invalidateQueries({ queryKey: ['alerts'] })
    queryClient.invalidateQueries({ queryKey: ['alerts-all'] })
    queryClient.invalidateQueries({ queryKey: ['sources', activeProject?.id, 'alert'] })
  }

  const { data: alertDataTypes } = useQuery({
    queryKey: ['types', 'alert'],
    queryFn: () => fetchMissionDataTypesByGroup('alert'),
  })

  useEffect(() => {
    if (alerts && map && sourcesActiveNames) {
      map.getSource('alerts')?.setData({
        type: 'FeatureCollection',
        features: (alerts ?? []).map((alert) => {
          const { geometry, properties = {} } = alert

          return {
            type: 'Feature',
            properties: {
              ...properties,
              color: alertDataTypes?.find(type => type.id === properties.dataType)?.color || '#000000',
            },
            geometry,
          }
        }),
      })
    }
    return () => {
      if (map?.getSource('alerts')) {
        map.getSource('alerts')?.setData({
          type: 'FeatureCollection',
          features: [],
        })
      }
    }
  }, [map, alertDataTypes, alerts, sourcesActiveNames])

  return (
    <div className="alerts">
      <Outlet context={{ map, alerts, refetchAlerts, alertDataTypes }} />
    </div>
  )
}

export default Alerts
